<div class="footer white">
    <div class="right">
      <img class="material-icons" src="../../../assets/copyright-white-18dp.svg" />2020 - {{data | date:'yyyy'}}. Todo os direitos reservados
    </div>
  </div>